import React from "react";
import copy from 'copy-to-clipboard';
import './style.scss'
import { message } from "antd";
export default function Contact() {

    const handleClick = (value) => {
        copy(value);
        message.info("Copy successfully!")
    }

    return <div className="contact-box">
        <div className="page-contact">
            <div className="contact-title">Contact</div>
            <div className="contact-con">
                For any further questions, you can contact us at &nbsp;
                <span>lbo@illinois.edu</span>
                <img onClick={() => {handleClick('lbo@illinois.edu')}} alt="" src="https://img.alicdn.com/imgextra/i2/O1CN01MDTQnR2129o1tk8Cj_!!6000000006926-2-tps-32-32.png" />
            </div>
        </div>
    </div>
}

